import { Injectable, signal } from '@angular/core'

export interface DialogState {
  search: boolean
  language: boolean
  logout: boolean
  menu: boolean
  nl: boolean
  products: boolean
  company: boolean
  profile: boolean
  [key: string]: boolean
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private initialState: DialogState = {
    search: false,
    language: false,
    logout: false,
    menu: false,
    nl: false,
    products: false,
    company: false,
    profile: false,
  }

  // A signal, not a BehaviorSubject: the components that render these dialogs
  // are OnPush (the Angular 22 default) and are not the ones handling the click
  // that opens them, so nothing else would ever mark their views dirty.
  private readonly dialogState = signal<DialogState>(this.initialState)

  toggleDropdown(dropdownKey: keyof DialogState): void {
    const dropdowns: (keyof DialogState)[] = [
      'products',
      'company',
      'languageMenu',
      'profile',
    ]
    dropdowns.forEach(key => {
      if (key !== dropdownKey) {
        this.toggle(key, false)
      }
    })

    // Explicitly toggle the target dropdown
    this.dialogState.update(current => ({
      ...current,
      [dropdownKey]: !current[dropdownKey],
    }))
  }

  toggle(dialogKey: keyof DialogState, value?: boolean): void {
    this.dialogState.update(current => ({
      ...current,
      [dialogKey]: value !== undefined ? value : !current[dialogKey],
    }))
  }

  closeAll(): void {
    this.dialogState.set({ ...this.initialState })
  }

  isOpen(dialogKey: keyof DialogState): boolean {
    return this.dialogState()[dialogKey]
  }
}
